import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjb250YWluZXIlMjBzaGlwJTIwcG9ydHxlbnwwfHx8fDE3ODM1MDI2MzV8MA&ixlib=rb-4.1.0&q=85"
                alt="Stacked cargo containers at export terminal"
                className="w-full h-[480px] object-cover rounded-3xl shadow-xl"
              />
              <div className="absolute -bottom-6 -right-6 hidden md:block">
                <div className="glass rounded-2xl p-5 w-64">
                  <div className="text-xs uppercase tracking-widest text-emerald font-semibold">Our Mission</div>
                  <div className="mt-2 font-display text-navy font-bold leading-snug">
                    Building long-term export partnerships, not one-off shipments.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="overline mb-4">Our Story</div>
            <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
              Making Indian FMCG sourcing simple, reliable & transparent for buyers worldwide.
            </h2>
            <div className="mt-6 space-y-4 text-slate-600 text-lg leading-relaxed">
              <p>
                Babul Corporation was founded with one mission — to make sourcing
                authentic Indian FMCG products simple, reliable and transparent for
                importers across the globe.
              </p>
              <p>
                With strong roots in India's FMCG distribution industry, we
                understand procurement, inventory management and international
                trade. Many overseas buyers struggled to find dependable suppliers
                who could consistently provide genuine branded products while
                handling export documentation professionally.
              </p>
              <p className="text-navy font-medium">
                Our approach is different — we believe in building long-term export
                partnerships instead of simply selling products.
              </p>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              {[
                "Sourcing through authorized channels",
                "Pre-dispatch quality inspection",
                "End-to-end export documentation",
                "Coordinated global logistics",
              ].map((t) => (
                <div key={t} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-emerald mt-0.5 shrink-0" />
                  <span className="text-slate-700 font-medium">{t}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 p-6 lg:p-8 rounded-2xl bg-navy text-white">
              <div className="overline text-gold" style={{ color: "var(--gold)" }}>Mission</div>
              <p className="mt-3 font-display text-xl lg:text-2xl leading-snug">
                To become one of India's most trusted merchant exporters by connecting
                authentic Indian brands with businesses worldwide through reliable sourcing,
                transparent communication and dependable export services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
